import * as React from 'react';
import * as styles from './styles.css';
import { ESuggestType, EInputType } from '../../types';
import { isBuildingSuggest } from '../../utils/types';
import { getClosingForMatch } from '../../utils/text';
import { mergeStyles } from '@cian/utils';
var UNDERGROUND_LINE_SHIFT = 4;

var renderUndergroundLines = function renderUndergroundLines(lines, isMobile) {
  if (!lines.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", mergeStyles(styles['lines-container'], isMobile && styles['lines-container--mobile']), lines.map(function (line, index) {
    var zIndex = lines.length;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles['underground-line'],
      style: {
        backgroundColor: "#".concat(line.lineColor),
        left: UNDERGROUND_LINE_SHIFT * index,
        zIndex: zIndex - index
      }
    });
  }));
};

function renderItemContent(item, isMobile) {
  var text;
  var matchesUnsorted;

  if (item.type === ESuggestType.geo) {
    text = item.displayName;
    matchesUnsorted = item.hl;
  } else {
    text = item.name;
    matchesUnsorted = item.matches;
  }

  var matches = matchesUnsorted && matchesUnsorted.sort(function (matchA, matchB) {
    return matchA[0] - matchB[0];
  }) || [];
  var value = (text || '').trim();
  return /*#__PURE__*/React.createElement("span", {
    className: styles['relative']
  }, item.type === ESuggestType.underground && renderUndergroundLines(item.lines, isMobile), !value || matches.length === 0 ? /*#__PURE__*/React.createElement("span", null, text) : matches.map(function (match, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      title: text
    }, index === 0 && text.substring(0, match[0]), /*#__PURE__*/React.createElement("strong", null, text.substring(match[0], match[1])), getClosingForMatch(text, matches, index));
  }), item.type === ESuggestType.underground && item.releaseYear && /*#__PURE__*/React.createElement("span", null, " \xB7 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0432 ".concat(item.releaseYear)));
}

export var getSuggestionStyles = function getSuggestionStyles(item, selected) {
  var itemStyles = [styles['item'], selected && styles['item-selected']];

  if (isBuildingSuggest(item)) {
    itemStyles.push(styles['item-building']);
  }

  return itemStyles;
};
export var getSuggestionContent = function getSuggestionContent(item, inputType, onLinkClick) {
  var shouldRenderLink = !(inputType === EInputType.mobile || inputType === EInputType.tablet);
  var isMobile = !(inputType === EInputType.search || inputType === EInputType.mainpage);
  var content = renderItemContent(item, isMobile);

  if (isBuildingSuggest(item)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles['building-name']
    }, content), /*#__PURE__*/React.createElement("div", {
      className: styles['address']
    }, item.address), item.link && shouldRenderLink &&
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-target-blank
    React.createElement("a", {
      className: styles['link'],
      href: item.link,
      target: "_blank",
      onClick: onLinkClick
    }, /*#__PURE__*/React.createElement("i", {
      className: styles['link-icon']
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      viewBox: "0 0 12 12"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#2B87DB",
      fillRule: "evenodd",
      d: "M12 .5V5h-1V1H7V0h5v.5zM0 1h1v10H0V1zm1 11v-1h10v1H1zM5 0v1H1V0h4zm7 11h-1V7h1v4zM10 1h1v1h-1V1zM9 2h1v1H9V2zM8 3h1v1H8V3zM7 4h1v1H7V4zM6 5h1v1H6V5z"
    })))));
  } else {
    return content;
  }
};